export const apiUrl = "https://codefolio-server.herokuapp.com"
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
